'use strict'

import {
    serverApi
} from '@/server';


export default {
    /**
     * 打款批次列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /bulk-pay-records
     */
    bulkPayDetails(formData) {
        let url = `/pay-details`;
        return serverApi.get(formData, url);
    },

    /**
     * 打款批次列表
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /bulk-pay-records
     */
     addBulkPayDetails(formData) {
        let url = `/add-pay-details`;
        return serverApi.get(formData, url);
    },

    /**
     * 商户下的通道
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: mch-channel-list/${mchId}
     */
    mchChannelList(mchId) {
        let url = `mch-channel-list/${mchId}`;
        return serverApi.get(formData, url);
    },
    /**
     * 电子回单下载
     *
     */
    receiptFileShow(payNo, fileName) {
      const url = `/receipt-file/${payNo}`

      return serverApi.downLoadByPost({}, url, payNo + '.pdf',true);
    },
    /**
     * 收款账号脱敏查看
     *
     * @author nick
     *
     * @param {String} payNo - 流水号
     *
     *
     * @returns {Promise}
     *
     */
    agreementsShowCardNo(payNo) {
        const url = `/pay-details-show-cardno/${payNo}`

        return serverApi.get({}, url);
    },
    /**
     * 身份证号脱敏查看
     *
     * @author nick
     *
     * @param {String} payNo - 流水号
     *
     *
     * @returns {Promise}
     *
     */
    agreementsShowIdCard(payNo) {
        const url = `/pay-details-show-idcard/${payNo}`

        return serverApi.get({}, url);
    },
    /**
     * 手机号脱敏查看
     *
     * @author nick
     *
     * @param {String} payNo - 流水号
     *
     *
     * @returns {Promise}
     *
     */
    agreementsShowPhone(payNo) {
        const url = `/pay-details-show-phone/${payNo}`

        return serverApi.get({}, url);
    },
}
